import { Root } from './routes'

export const App: React.FC = () => <Root />
